export const environment = {
    production: true,
    url: 'https://panel-aseguratuhogar.solidusystems.mx',
    apiUrl: 'https://api-aseguratuhogar.solidusystems.mx/api/v1/admin',
    apiUrlLogin: 'https://api-aseguratuhogar.solidusystems.mx/api/v1',
    apiNoPrefix: 'https://api-aseguratuhogar.solidusystems.mx'
};
